import React from "react";

const About = () => {
  return (
    <div>
      <h2 style={{ color: "red", textAlign: "center", marginTop: "50px" }}>
        i don't say about mySelf !
      </h2>
    </div>
  );
};

export default About;
